module.exports = __webpack_public_path__ + "img/arrowLeftDisabled.e895db13.svg";